/**
 * @generated SignedSource<<3699a0a11b089f7e96a38aa965c2ab81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type eventSalesOrderFragment$data = {
  readonly id: string;
  readonly event: {
    readonly id: string;
    readonly beginsAt: any;
  };
  readonly " $fragmentType": "eventSalesOrderFragment";
};
export type eventSalesOrderFragment$key = {
  readonly " $data"?: eventSalesOrderFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"eventSalesOrderFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "eventSalesOrderFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Event",
      "kind": "LinkedField",
      "name": "event",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "beginsAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "EventGuest",
  "abstractKey": null
};
})();

(node as any).hash = "0e352fa6be91150f750b810f6fc932fc";

export default node;
